import {
	getEventTargetElement,
} from './Util';

class DySearchFeedbackController {
	constructor( containerEl ) {
		this.containerEl = containerEl;
		this.init();
	}

	getScoreFromButton( buttonEl ) {
		const score = Number( buttonEl.dataset.feedbackScore || '' );

		if ( ! Number.isInteger( score ) || score < 1 || score > 5 ) {
			return null;
		}

		return score;
	}

	selectScore( buttonEl, score ) {
		this.containerEl.classList.add( 'is-voted' );
		this.containerEl.querySelectorAll( '.mdl_aftersearch_feedback__trigger.is-selected' ).forEach( ( selectedEl ) => {
			selectedEl.classList.remove( 'is-selected' );
		} );
		buttonEl.classList.add( 'is-selected' );

		const thankyouEl = this.containerEl.querySelector( '.mdl_aftersearch_feedback__thankyou' );
		thankyouEl?.classList.remove( 'en_hidden' );

		const params = new URLSearchParams( window.location.search );

		this.containerEl.dispatchEvent( new CustomEvent( 'dy_aftersearch_feedback', {
			bubbles: true,
			detail: {
				score: buttonEl.getAttribute( 'data-feedback-score' ),
				searchterm: params.get( 'query' ),
			},
		} ) );
	}

	init() {
		this.containerEl.addEventListener( 'click', ( event ) => {
			if ( this.containerEl.classList.contains( 'is-voted' ) ) {
				return;
			}

			const target = getEventTargetElement( event );
			const buttonEl = target?.closest( '.mdl_aftersearch_feedback__trigger' );

			if ( ! buttonEl || ! this.containerEl.contains( buttonEl ) ) {
				return;
			}

			const score = this.getScoreFromButton( buttonEl );

			if ( score === null ) {
				return;
			}

			this.selectScore( buttonEl, score );
		} );
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.mdl_aftersearch_feedback' ).forEach( ( containerEl ) => {
		containerEl.DY_SEARCH_FEEDBACK_CONTROLLER ??= new DySearchFeedbackController( containerEl );
	} );
} );
